import { NavigationTabs } from "../../../../../../../../components/NavigationTabs";
import {
  SCOPE_3_CATEGORIES_KEYS,
  SCOPE_3_CATEGORIES_STEPS
} from "../../../../../../../SupplierQuestionnaire/components/Revenue/components/ScopeThree/const";
import { t } from "i18next";
import { CategoryOne, CategoryThree, CategoryTwo, ReusableCategory } from "./components";
import { Box, Button, Flex, Text, useBreakpointValue } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import React from "react";

// There is specific component for each of the first three categories
const categoriesMap = {
  [SCOPE_3_CATEGORIES_KEYS['categoryOne']]: CategoryOne,
  [SCOPE_3_CATEGORIES_KEYS['categoryTwo']]: CategoryTwo,
  [SCOPE_3_CATEGORIES_KEYS['categoryThree']]: CategoryThree,
}

function mapData(data) {
  const elements = [];
  SCOPE_3_CATEGORIES_STEPS.forEach(categoryKey => {
    elements.push({
      // If there is no specific component for a category, we use ReusableCategory component
      component: categoriesMap[categoryKey] ?? ReusableCategory,
      data: data[categoryKey],
      id: categoryKey,
      name: `Category ${SCOPE_3_CATEGORIES_STEPS.indexOf(categoryKey) + 1}`,
      subtitle: t(`supplierQuestionnaire.scopeThree.categories.${categoryKey}.name`),
      customTabPanelTitle: `Category ${SCOPE_3_CATEGORIES_STEPS.indexOf(categoryKey) + 1}: ${t(`supplierQuestionnaire.scopeThree.categories.${categoryKey}.name`)}`
    });
  });
  return elements;
}

function ScopeThreeQuestions({ data, handleExportClick }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "reportsPage.suppliersData"
  });
  const headerContainerDisplay = useBreakpointValue({
    lg: "flex",
    base: "block"
  });
  const categoryElements = mapData(data);

  return (
    <>
      <Flex
        justifyContent="space-between"
        alignItems="center"
        paddingRight="5"
        marginBottom={3}
        display={headerContainerDisplay}
      >
        <Box paddingBlock="2">
          <Text opacity="0.75">
            {t("aggregatedScopeThreeSubTitle")}
          </Text>
        </Box>
        <Button
          colorScheme="customScheme"
          type="submit"
          title={t("exportBtnTitle")}
          width="max-content"
          onClick={handleExportClick}
        >
          {t("exportBtn")}
        </Button>
      </Flex>
      <NavigationTabs
        elements={categoryElements}
        tabTitle={"Category"}
        subTitleAttribute={"subtitle"}
        saveMethod={null}
        customNavButton={null}
      />
    </>

  )
}

export default ScopeThreeQuestions;